import { useState } from 'react';
import uniqid from 'uniqid';
import GitHubIcon from '@material-ui/icons/GitHub';
import LaunchIcon from '@material-ui/icons/Launch';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './ProjectContainer.css';

const STACK_LIMIT = 6;

const ProjectContainer = ({ project }) => {
  const [expanded, setExpanded] = useState(false);
  const [showAllStack, setShowAllStack] = useState(false);

  const visibleStack = showAllStack
    ? project.stack
    : project.stack?.slice(0, STACK_LIMIT);

  const hasMoreStack = project.stack?.length > STACK_LIMIT;

  return (
    <div className='project glass-card'>
      <div className='project__header'>
        <div className='project__title-wrap'>
          <h3>{project.name}</h3>
          {project.dates && (
            <span className='project__dates'>{project.dates}</span>
          )}
        </div>
        <div className='project__header-right'>
          {project.badge && (
            <span className='project__badge'>{project.badge}</span>
          )}
          <div className='project__links'>
            {project.sourceCode && (
              <a
                href={project.sourceCode}
                aria-label='source code'
                className='link link--icon project__link'
                target='_blank'
                rel='noreferrer'
              >
                <GitHubIcon />
              </a>
            )}
            {project.paperLink && (
              <a
                href={project.paperLink}
                aria-label='read paper'
                className='link link--icon project__link'
                target='_blank'
                rel='noreferrer'
              >
                <MenuBookIcon />
              </a>
            )}
            {project.livePreview && (
              <a
                href={project.livePreview}
                aria-label='live preview'
                className='link link--icon project__link'
                target='_blank'
                rel='noreferrer'
              >
                <LaunchIcon />
              </a>
            )}
          </div>
        </div>
      </div>

      <p
        className={`project__description ${
          expanded ? 'project__description--expanded' : ''
        }`}
      >
        {project.description}
      </p>

      {project.description.length > 160 && (
        <button
          type='button'
          className='project__toggle'
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
        >
          {expanded ? 'Show less' : 'Read more'}
          <ExpandMoreIcon
            className={`project__toggle-icon ${
              expanded ? 'project__toggle-icon--up' : ''
            }`}
          />
        </button>
      )}

      {project.stack && (
        <ul className='project__stack'>
          {visibleStack.map((item) => (
            <li key={uniqid()} className='project__stack-item'>
              {item}
            </li>
          ))}
        </ul>
      )}

      {hasMoreStack && (
        <button
          type='button'
          className='project__stack-toggle'
          onClick={() => setShowAllStack(!showAllStack)}
        >
          {showAllStack
            ? 'Show fewer'
            : `+${project.stack.length - STACK_LIMIT} more`}
        </button>
      )}
    </div>
  );
};

export default ProjectContainer;
